import { notifyGlobalError } from 'Utilities/notifyBridge';

export const initGlobalErrorHandlers = () => {
  window.addEventListener('error', (event) => {
    console.error('Unhandled error:', event.error ?? event.message);
    notifyGlobalError('Something went wrong.');
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    notifyGlobalError('Something went wrong.');
  });
};
